<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-3" lang="en-GB"><a id="_idTextAnchor004"></a>A man’s gift (his talent)</h1>
<p class="Verse-first" lang="en-GB">Pay attention to me oh you gifted one</p>
<p class="Verse-main" lang="en-GB">Be aware of me you called talented</p>
<p class="Verse-main" lang="en-GB">I am the reason they love you so</p>
<p class="Verse-main" lang="en-GB">The reason for much celebration and adoration</p>
<p class="Verse-main" lang="en-GB">I exalt you now and then</p>
<p class="Verse-main" lang="en-GB">I make your name greater than you</p>
<p class="Verse-main" lang="en-GB">I am your friend yet your enemy</p>
<p class="Verse-main" lang="en-GB">I bring you up and down</p>
<p class="Verse-main" lang="en-GB">I steal your character I destroy slowly</p>
<p class="Verse-main" lang="en-GB">I bring two desirable affairs fame and fortune</p>
<p class="Verse-main" lang="en-GB">I take simplicity from the heart</p>
<p class="Verse-main" lang="en-GB">I am your gift regard me with care</p>
<p class="Verse-main" lang="en-GB">I steal from you humility</p>
<p class="Verse-main" lang="en-GB">I bring supremacy and take away meekness</p>
<p class="Verse-main" lang="en-GB">I can take more than I give </p>
<p class="Verse-main" lang="en-GB">I am just a gift</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB5.vue?f2ce5662